import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Col, Row } from 'antd';
import { message } from 'components/common';
import { SecondaryButton } from 'components/common/styles';
import {
  GreenColor,
  SmartBackButton,
  SmartFormLabel,
  SmartScanner,
  SmartSpace,
  SmartSpin,
  playSound,
} from 'components/Sales/Smart/SmartComponent';
import { fetchPoList } from 'services/purchaseOrder';
import PoListView from './PoListView';
import { PoRecvActionType as PRAction } from './context';

type Props = ReduxStateProps & {
  onSelectPo: Function;
};

const PHeight1 = 10;

const ScanPo = (props: Props) => {
  const { useRef, useState } = React;
  // eslint-disable-next-line
  const [autoFocus, setAutoFocus] = useState(1)
  const [contentWrapperHeight, setContentWrapperHeight] = useState(0);
  const [contentWrapperStyle, setContentWrapperStyle] = useState<StringKAnyVPair>({});
  const [isFetching, setIsFetching] = useState(false);
  const history = useHistory();
  const { t } = useTranslation();
  const inputCtn = useRef<any>(null);
  const contentWrapper = useRef<any>(null);
  const footer = useRef<any>(null);

  const adjustContentLayout = () => {
    let [h1, h2, h3] = [0, 0, 0];
    let t1 = 0;

    if (inputCtn.current) {
      const ctn = inputCtn.current;

      h1 = ctn.offsetHeight;
      t1 = ctn.offsetTop;
    }

    if (footer.current) {
      h3 = footer.current.offsetHeight;
    }

    if (contentWrapper.current) {
      const wh = window.innerHeight;

      h2 = wh - t1 - h1 - h3 - PHeight1 * 3;
    }
    //console.log(h1, h2, h3, t1);
    setContentWrapperHeight(h2);
    setContentWrapperStyle({height: h2, marginBottom: 0});
  };

  const footerButtons = () => {
    return (
      <Row justify="space-between">
        <Col span={12} style={{paddingRight: 5}}>
          <SecondaryButton
            onClick={() => handleScannerChange('')}
            size="large"
            style={{width: '100%'}}
            type="primary"
          >
            Browse PO(s)
          </SecondaryButton>
        </Col>
        <Col span={12} style={{paddingLeft: 5}}>
          <Button
            //onClick={() => history.goBack()}
            onClick={() => history.push('/smart')}
            size="large"
            style={{width: '100%'}}
            type="primary"
          >
            {t("smart.common.goBack")}
          </Button>
        </Col>
      </Row>
    );
  };

  const getPoList = async (
    poNumberSearchValue: string,
    typeName = 'poNumber',
  ) => {
    setIsFetching(true);
    try {
      const polist = await fetchPoList({
        warehouseCode: props.state.selectedWarehouse.warehouseCode,
        filterFieldName: typeName,
        filterKey: poNumberSearchValue || '',
        poStatus: [1, 2].join(','),
        //poStatusNum: -1,
        sortBy: 'fulfillmentPoNum desc',
        skip: 0,
        limit: 100,
      });

      if (polist.data.length === 0) {
        playSound('error');
        return message.warning({ content: `No PO[${poNumberSearchValue}] matched` });
      }

      props.dispatch({
        type: PRAction.SetPoList,
        params: polist.data.map((item) => {
          return { ...item, receivingQty: 0 };
        })
      });
      console.log('pl', polist.data);
      if (polist.data.length > 1) {
        //setSelectPoDialogVisible(true);
        setTimeout(adjustContentLayout, 0);
      } else {
        //checkWarehouse(polist.data[0]);
        props.onSelectPo(polist.data[0]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsFetching(false);
    }
  };
  // const getPoListBySku =

  const handleScannerChange = (val: string) => {
    const sk = val.trim();
    //console.log('val', val);
    if (sk !== '')  playSound('bell');

    getPoList(sk);
  };

  return (<>
    <SmartSpin loading={isFetching} />
    <SmartSpace ref={inputCtn} style={{marginBottom: PHeight1}}>
      <SmartFormLabel
        style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
      >
        {t("smart.poreceive.scanToStart")}
      </SmartFormLabel>
      <SmartScanner
        disabled={isFetching}
        isAutoFocus={autoFocus}
        placeholder="Input PO# here"
        style={{ marginTop: 10 }}
        onChangeValue={handleScannerChange}
      />
    </SmartSpace>
    <SmartSpace ref={footer} style={{marginBottom: PHeight1}}>
      <SmartBackButton
        children={footerButtons()}
        onHeightChange={() => setTimeout(adjustContentLayout, 0)}
      />
    </SmartSpace>
    {props.state.poList.length > 0 && (
      <SmartSpace
        ref={contentWrapper}
        style={contentWrapperStyle}
      >
        <PoListView
          height={contentWrapperHeight}
          onSelectPo={props.onSelectPo}
          poList={props.state.poList}
        />
      </SmartSpace>
    )}
  </>);
};

export default ScanPo;
